import { render, staticRenderFns } from "./AssociatesTab.vue?vue&type=template&id=0835652c&scoped=true&"
import script from "./AssociatesTab.vue?vue&type=script&lang=js&"
export * from "./AssociatesTab.vue?vue&type=script&lang=js&"
import style0 from "./AssociatesTab.vue?vue&type=style&index=0&id=0835652c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835652c",
  null
  
)

export default component.exports